<template>
  <div class="w-full">
    <div class="p-0 relative">
      <div class="header" v-show="visibleBottom">
        <div v-if="!screen.isMobile">
          <h1>Mapa de Territorio</h1>
          <div>Opciones de visualización</div>
        </div>
        <div class="options" v-if="ready">
          <MapControl ref="control"  @setSize="setSize" @hide="visibleBottom = false" />
        </div>
      </div>
      <div class="grid grid-nogutter max-page w-full">    
        <div class="col">
          <MapaBase
            class="map"
            ref="mapaBase"
            :style="size"
            zoom="15"
            :center="center"
            :editing="false"
            :saveCenter="false"
            @mapMoveend="onMapMoveend"
            @ready="ready"
            ></MapaBase>
            <!-- @mapClick="onMapClick"
            @zoomstart="zoomstart"
            @zoomend="zoomend" -->
        </div>
    </div>
    </div>
  </div>
  <Button icon="pi pi-arrow-up" label="Configurar Mapa" severity="help" raised @click="visibleBottom = true" style="position: absolute; bottom: 10px; z-index: 1000; width: 200px; left: calc(50% - 100px)" v-if="!visibleBottom" />
  <!-- <Sidebar v-model:visible="visibleBottom" header="Bottom Sidebar" position="bottom" style="height: auto">
    <MapControl ref="control"  @setSize="setSize"  v-if="ready" />
  </Sidebar> -->
</template>

<script setup>
import { computed, ref } from "vue";
import { useTerritorioStore } from "@/store/territorio";
import { useTerritoriosStore } from "@/store/territorios";
import { useScreenStore } from "@/store/useScreenStore";

const visibleBottom = ref(false);
const mapaBase = ref(null);
const screen = useScreenStore();

const terr = useTerritorioStore();
const territorios = useTerritoriosStore();

const step = ref(0);
const control = ref('');
const size = ref('');

const center = computed(() => terr.center || territorios.list[0]?.center || [19.4326, -99.1332]);

const setSize = (data) => {
  step.value = 3
  size.value = data.value
  setTimeout(()=> { step.value = 0 }, 200)
}


const onMapMoveend = (e) => {
  terr.$patch({ center: mapaBase.value.m.getCenter() });
};


const ready = async () => {
  console.log('ready', control.value)
  if (!control.value) return;
  await control.value.setMapaBase(mapaBase.value);
  control.value.filter();
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  text-align: left;
  position: absolute;
  bottom: 20px;
  left: 0px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: saturate(180%) blur(8px);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-2);
  z-index: 1000;
  padding: var(--space-3);
}
h1, h2 {
  font-weight: var(--weight-light);
  margin: 0;
  padding: 0;
  color: var(--label-primary);
}
.max-page {
  min-height: 85vh;
  /* height: calc(100vh - 8em); */
}
/* p {
  color: grey;
  font-size: 0.8em;
} */
.stepActive {
  /* border-top: 1px solid red; */
  background-color: aliceblue;
}
</style>
